var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSilverBadge = function SvgSilverBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 18,
    height: 14,
    rx: 4,
    fill: "url(#silverBadge_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.25h-.055c-1.367 0-2.47 0-3.337.117-.9.12-1.658.38-2.26.981-.602.602-.86 1.36-.981 2.26-.049.36-.077.762-.094 1.206a.751.751 0 0 0-.01.327c-.013.541-.013 1.142-.013 1.804V13.055c0 1.367 0 2.47.117 3.337.12.9.38 1.658.981 2.26l.518-.518-.518.518c.602.602 1.36.86 2.26.982.867.116 1.97.116 3.337.116H16a.75.75 0 0 0 0-1.5H8c-1.435 0-2.437-.002-3.192-.103-.734-.099-1.122-.28-1.399-.556-.277-.277-.457-.665-.556-1.4-.101-.754-.103-1.756-.103-3.191v-2c0-.459 0-.874.004-1.25h16.492c.004.376.004.791.004 1.25v4.5a.75.75 0 0 0 1.5 0v-4.555c0-.662 0-1.263-.013-1.804a.752.752 0 0 0-.01-.327 12.69 12.69 0 0 0-.093-1.206c-.122-.9-.38-1.658-.982-2.26-.602-.602-1.36-.86-2.26-.981-.867-.117-1.97-.117-3.337-.117H8Zm11.193 4a8.306 8.306 0 0 0-.046-.442c-.099-.734-.28-1.122-.556-1.399-.277-.277-.665-.457-1.4-.556-.755-.101-1.756-.103-3.191-.103H8c-1.435 0-2.437.002-3.192.103-.734.099-1.122.28-1.399.556-.277.277-.457.665-.556 1.4a8.274 8.274 0 0 0-.046.441h16.386Z",
    fill: "#40180B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13h3",
    stroke: "#050400",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.698 20.656-.198.644-.198-.644c-.579-1.881-2.012-3.402-3.887-4.156 1.875-.754 3.308-2.275 3.887-4.157l.198-.643.198.643c.578 1.882 2.012 3.403 3.887 4.157-1.875.754-3.309 2.274-3.887 4.156Z",
    fill: "url(#silverBadge_svg__b)",
    stroke: "#40180B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "silverBadge_svg__a",
    x1: 9.903,
    y1: 6.949,
    x2: 20.216,
    y2: 16.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "silverBadge_svg__b",
    x1: 16.83,
    y1: 11.81,
    x2: 25.439,
    y2: 17.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })))));
};
export default SvgSilverBadge;